const jsonToProps = ({ component_id, link_label, ...rest }) => ({
  ...rest,
  linkLabel: link_label,
  url: link_label.target,
  target: link_label.html_target,
  highlightedText: link_label.label.values.blue_text,
});

export default jsonToProps;
